import { render, staticRenderFns, recyclableRender, components } from "./my-points.vue?vue&type=template&id=7c36d490&scoped=true&"
var renderjs
import script from "./my-points.vue?vue&type=script&lang=js&"
export * from "./my-points.vue?vue&type=script&lang=js&"
import style0 from "./my-points.vue?vue&type=style&index=0&lang=css&"
import style1 from "./my-points.vue?vue&type=style&index=1&id=7c36d490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c36d490",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/my-points/my-points.vue"
export default component.exports